/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "tiktok--sprite",
  "use": "tiktok--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"tiktok--sprite\"><path stroke=\"null\" d=\"M18.898 2.947H5.102a2.158 2.158 0 0 0-2.155 2.155v13.796c0 1.188.967 2.155 2.155 2.155h13.796a2.158 2.158 0 0 0 2.155-2.155V5.102a2.158 2.158 0 0 0-2.155-2.155m-1.722 7.899a3.226 3.226 0 0 1-.297.015 3.23 3.23 0 0 1-2.703-1.46v4.973a3.676 3.676 0 1 1-3.676-3.676c.076 0 .151.007.227.012v1.811c-.076-.009-.15-.023-.227-.023a1.876 1.876 0 1 0 0 3.753c1.036 0 1.951-.817 1.951-1.853l.018-8.447h1.734a3.228 3.228 0 0 0 2.975 2.882v2.013\" /></symbol>"
});
sprite.add(symbol);
var viewBoxValues = symbol.viewBox ? symbol.viewBox.split(' ') : []

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox,
      width: viewBoxValues[2],
      height: viewBoxValues[3]
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.width = viewBoxValues[2];
SvgSpriteIcon.height = viewBoxValues[3];
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
